/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'licensing';
const componentName = 'license-tier-switch-modal';
const prefix = `${moduleName}.${componentName}`;

export const clusterNameLabel = `${prefix}.clusterNameLabel`;
export const clusterNamePlaceholder = `${prefix}.clusterNamePlaceholder`;
export const completeSetupDescription = `${prefix}.completeSetupDescription`;
export const configureCloudServices = `${prefix}.configureCloudServices`;
export const connectNow = `${prefix}.connectNow`;
export const contactInputLabel = `${prefix}.contactInputLabel`;
export const contactInputPlaceholder = `${prefix}.contactInputPlaceholder`;
export const controllerDeregistrationMessage = `${prefix}.controllerDeregistrationMessage`;
export const defaultSaveTierChangeErrorMessage = `${prefix}.defaultSaveTierChangeErrorMessage`;
export const disconnectFromOnPremDescription = `${prefix}.disconnectFromOnPremDescription`;
export const failedToConnectCloudLicensingError = `${prefix}.failedToConnectCloudLicensingError`;
export const insufficientLicensesMessage = `${prefix}.insufficientLicensesMessage`;
export const licensePoolSelectionInputLabel = `${prefix}.licensePoolSelectionInputLabel`;
export const licensePoolSelectionInputPlaceholder = `${prefix}.licensePoolSelectionInputPlaceholder`;
export const licensingConnectivityError = `${prefix}.licensingConnectivityError`;
export const maxServiceUnitsLabel = `${prefix}.maxServiceUnitsLabel`;
export const maxServiceUnitsPlaceholder = `${prefix}.maxServiceUnitsPlaceholder`;
export const modalTitle = `${prefix}.modalTitle`;
export const proxyHeaderLabel = `${prefix}.proxyHeaderLabel`;
export const reserveServiceUnitsLabel = `${prefix}.reserveServiceUnitsLabel`;
export const reserveServiceUnitsPlaceholder = `${prefix}.reserveServiceUnitsPlaceholder`;
export const saveAndContinue = `${prefix}.saveAndContinue`;
export const siteInputPlaceholder = `${prefix}.siteInputPlaceholder`;
export const siteNameInputLabel = `${prefix}.siteNameInputLabel`;
export const someFeaturesOnlyAvailableMessage = `${prefix}.someFeaturesOnlyAvailableMessage`;
export const switchLicenseHeader = `${prefix}.switchLicenseHeader`;
export const switchToCloudDescription = `${prefix}.switchToCloudDescription`;
export const switchToOnPremDescription = `${prefix}.switchToOnPremDescription`;
export const unlockMoreFeaturesMessage = `${prefix}.unlockMoreFeaturesMessage`;
export const nodeSettingsLabel = `${prefix}.nodeSettingsLabel`;
export const systemSettingsLabel = `${prefix}.systemSettingsLabel`;
export const proxySettingsLabel = `${prefix}.proxySettingsLabel`;
export const proxyServerHostLabel = `${prefix}.proxyServerHostLabel`;
export const proxyServerHostPlaceholder = `${prefix}.proxyServerHostPlaceholder`;

export const ENGLISH = {
    [clusterNameLabel]: 'Cluster Name',
    [clusterNamePlaceholder]: 'Enter Cluster Name',
    [completeSetupDescription]: 'Complete setup by connecting to cloud licensing for enhanced features.',
    [configureCloudServices]: 'Configure Cloud Services',
    [connectNow]: 'Connect Now',
    [contactInputLabel]: 'Default Contact',
    [contactInputPlaceholder]: 'Select Contact',
    [controllerDeregistrationMessage]: 'In order to switch to {0} the Controller will be deregistered from Cloud Services.',
    [defaultSaveTierChangeErrorMessage]: 'An error occurred while saving license tier change.',
    [disconnectFromOnPremDescription]: 'How to disconnect from On-prem License Hub KB.',
    [failedToConnectCloudLicensingError]: 'Failed to connect to cloud licensing. Please try again.',
    [insufficientLicensesMessage]: 'Insufficient Service Core Licenses to switch to {0} License',
    [licensePoolSelectionInputLabel]: 'License Pool Selection',
    [licensePoolSelectionInputPlaceholder]: 'Select License Pool Selection',
    [licensingConnectivityError]: 'There were some problem with license connectivity. Please try again.',
    [maxServiceUnitsLabel]: 'Maximum Allowed Licenses',
    [maxServiceUnitsPlaceholder]: 'Enter Maximum Allowed Licenses',
    [modalTitle]: 'Licensing',
    [proxyHeaderLabel]: 'Proxy',
    [reserveServiceUnitsLabel]: 'Number of Reserved Licenses',
    [reserveServiceUnitsPlaceholder]: 'Enter Number of Reserved Licenses',
    [saveAndContinue]: 'Save & Continue',
    [siteInputPlaceholder]: 'Select Site',
    [siteNameInputLabel]: 'Site',
    [someFeaturesOnlyAvailableMessage]: 'Some features are only available in {0}, switching to {1} will deactivate these features',
    [switchLicenseHeader]: 'Tier Switching',
    [switchToCloudDescription]: 'To switch to Cloud Licensing, you need to first disconnect from the On-Prem License Hub.',
    [switchToOnPremDescription]: 'To switch to On-prem License Hub, you must first disconnect from the Cloud Licensing.',
    [unlockMoreFeaturesMessage]: 'Unlock more features and possibilities with {0} License',
    [nodeSettingsLabel]: 'Node Settings',
    [systemSettingsLabel]: 'System Settings',
    [proxySettingsLabel]: 'Proxy Settings',
    [proxyServerHostLabel]: 'Server Host',
    [proxyServerHostPlaceholder]: 'Enter Server Host',
};
